import { createContext, useContext, useEffect, useState } from "react";
import { content } from "./content";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("cb_lang_preference");
    return saved === "en" || saved === "fr" ? saved : "fr";
  });

  useEffect(() => {
    localStorage.setItem("cb_lang_preference", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: content[lang] };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
